import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScrAuthorizationService } from '../../../services/authorization.service';
import { CacheService } from '../../../services/cache.service';
import { ScrBaseComponent, ScrBaseTabComponent } from 'src/app/components/base.component';
import { Account } from 'src/app/models/account.model';
import { BadgeData } from '../../../models/badge.model';
import { BADGECOUNTS } from 'src/app/shared/constants';
import { AccountService } from 'src/app/services/account.service';
import { ShortCodesRole } from '../../../models/constants';


export class TabConfig {
  public tabType = '';
  public routeElement = '';
  public objectId = '';
  public pathSegment: string[] = [];
}

@Component({
  selector: 'app-my-short-codes',
  templateUrl: './my-short-codes.component.html'
})
export class MyShortCodesComponent extends ScrBaseComponent implements OnInit {
  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;

  public tabs: TabConfig[] = [];
  transferCount = 0;
  invoiceCount = 0;
  needsActionCount = 0;
  cachedAccount: Account = {} as Account;

  constructor(private router: Router, private cache: CacheService, 
    private cacheService: CacheService, 
    private scrAuthorizationService: ScrAuthorizationService,
    private accountService: AccountService) {
    super();
    const saved = this.cache.get<TabConfig[]>('my-short-codes-tabs');
    if (saved) {
      this.tabs = saved;
      this.log.trace('ctor: tabs now ' + JSON.stringify(this.tabs));
    }
    else {
      this.log.trace('ctor: no saved tabs');
    }

  }

  ngOnInit(): void {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.forkedObserve<any>([
      this.accountService.getAccount(),
      this.scrAuthorizationService.getAuthorizedGroups()], (rsp) =>
    {
   
      this.cachedAccount = rsp[0].account;
      return false;
    });
    this.subscriptions.push(this.cacheService.subscribe<BadgeData>(BADGECOUNTS).subscribe(badgecounts => {
      if (badgecounts) {
        this.transferCount = badgecounts.transfersCount;
        this.invoiceCount = badgecounts.monthlyInvoiceCount;
        this.needsActionCount = badgecounts.needsActionCount;
      }
    }));
  }

  public componentAdded(child: ScrBaseTabComponent): void {

    if (!(child instanceof ScrBaseTabComponent)) {
      return ;
    }

    const tt = child.tt;
    const re = child.routeElement;
    const childObjectId = child.getObjectId();

    if (tt && re) {
      this.log.trace('child added ' + child);
      if (!this.tabs.some(t => {
        return (t.objectId === childObjectId) && (t.routeElement === re);// && (t.pathSegment[2] == childObjectId);
      })) {
        this.log.trace('add tab ' + re + ' ' + tt);
        const tc = new TabConfig();
        tc.objectId = childObjectId;
        tc.routeElement = re;
        tc.tabType = tt;
        tc.pathSegment = [tc.routeElement];
        child.getPathSegmentValues().forEach(v => tc.pathSegment.push(v));
        this.tabs.push(tc);
        this.log.trace('add tab, tabs now ' + JSON.stringify(this.tabs));
        this.cache.set('my-short-codes-tabs', this.tabs, 0);
      }
      else {
        this.log.trace('already such a tab ' + tt + ' ' + re + ' in ' + JSON.stringify(this.tabs));
      }
    }
  }

  closeTab(event: Event, routeElement: string, id: string): void {
    this.log.trace('close tab ' + routeElement + ' with id ' + id);
    this.tabs = this.tabs.filter(t => {
      return t.objectId !== id || t.routeElement !== routeElement;
    });
    this.log.trace('close tab, tabs now ' + JSON.stringify(this.tabs));

    this.cache.set('my-short-codes-tabs', this.tabs, 0);
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }]);
    event.preventDefault();
  }
}
